export const accountMovement = {
  accountMovementTransaction: "交易",
  accountMovementAmount: "金额",
  accountMovementDeposit: "存款",
  accountMovementTransfer: "转账",
  accountMovementBet: "投注",
  accountMovementWithdrawal: "提款",
  accountMovementBonus: "奖金",
  movementsBtnBack: "返回",
  accountMovementBetAll: "全部",
  accountMovementBetWon: "获胜",
  accountMovementBetLost: "失败",
  movementsDepositDesc: "您账户的存款记录",
  movementsTransferDesc: "用户之间的转账记录",
  movementsBetDesc: "投注和结果摘要",
  movementsWithdrawalDesc: "已处理的提款记录",
  movementsBonusDesc: "收到的奖金和促销活动",
  movementsTransferReceived: "已接收",
  movementsTransferSent: "已发送",
  movementsTotalBets: "总投注",
  movementsTotalWins: "总获胜",
  movementsNetResult: "净结果",
  movementsLoadMore: "加载更多",
  movementsEmptyTitle: "没有交易",
  movementsEmptyDesc: "您在此类别中还没有任何交易",
  paginationItemsPerPage: "/ 页",
  paginationJumpTo: "跳至",
  paginationJumpToConfirm: "确定",
  paginationPage: "页",
  paginationPrevPage: "上一页",
  paginationNextPage: "下一页",
  paginationPrev5: "向前 5 页",
  paginationNext5: "向后 5 页",
  paginationPrevPageTooltip: "上一页",
  paginationNextPageTooltip: "下一页",
  paginationOf: "共",
  paginationItems: "条",
};
